<template>
    <div>
        <coursechapters v-if="coursechapterscard == true"></coursechapters>
        <v-card class="box" v-if="show_card==true">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Create / View Question Bank
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center">
            <!-- {{quiz_type_list}} -->
            <v-btn class="button" v-for="(qtype, index) in quiz_type_list" :key="index" @click="add(qtype.quiz_type)">{{ qtype.display_name }}</v-btn>
            <v-btn class="button" @click="mcq_flag=false;subjective_flag=false;questionbank=true;">View Question Bank</v-btn>
            </v-row>
        </v-card>
       


        <!-- <mcq v-if="mcq_flag == true" :type="type" ></mcq>
        <livemtp v-if="live_mtp_flag == true" :type="type" :chapter="chapter"></livemtp>
        <subjective v-if="subjective_flag== true" :type="type" :chapter="chapter"></subjective>
        <viewquestionbank v-if="questionbank== true"></viewquestionbank> -->

    </div>
</template>
<script>
    import axios from "axios";
    import MCQ from "./MCQ";
    import Subjective from "./Subjective";
    import LiveMTP from "@/components/LiveClass/LiveMTPNew"
    import ViewQuestionBank from "./ViewQuestionBank"
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import CourseChapterCard from "./CourseChapterCard";
    export default {
        components: {
            mcq: MCQ,
            livemtp: LiveMTP,
            subjective: Subjective,
            viewquestionbank:ViewQuestionBank,
            coursechapters: CourseChapterCard,
        },
        data() {
            return {
                coursechapterscard:true,show_card:false,
                questionbank: false,
                mcq_flag: false,
                live_mtp_flag: false,
                subjective_flag: false,
                quiz_type_list:[],
                type:null,
            };
        },
        methods: {
            add(qtype){
                //alert(qtype)
                if(qtype == "MCQ"){
                    this.type = qtype
                    this.mcq_flag=true;this.subjective_flag=false;this.questionbank=false, this.live_mtp_flag=false
                }
                else if(qtype == "SUBJECTIVE"){
                     this.type = qtype
                    this.mcq_flag=false;this.subjective_flag=true;this.questionbank=false,this.live_mtp_flag=false
                }
                else if(qtype == "MTP"){
                     this.type = qtype
                     this.live_mtp_flag=true;this.subjective_flag=false;this.questionbank=false,this.mcq_flag=false
                }
            },
            getQuizTypeForQB() {
                axios
                    .post("/QuizQuestionBank/getQuizTypeForQB")
                    .then((res) => {
                        this.quiz_type_list = res.data.quiz_type_list;
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
        mounted(){
                this.getQuizTypeForQB();
            }
    };
</script>
<style scoped></style>
